import { api } from "./apiService";
import { getAuthKeyFromLocalStorage } from "../store/slices/employeeSlice";

// ============================================================
// Attendance Details
// ============================================================

const GetFilteredAttendanceDetails = async ({
    year,
    month,
    sno = "",
    fromDate,
    toDate,
}) => {
    const params = new URLSearchParams();

    if (year) params.append("year", year);
    if (month) params.append("month", month);
    if (sno) params.append("sno", sno);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);


    const token = getAuthKeyFromLocalStorage();
    const url = `/Attendence/GetFILLTERAttDetails?${params.toString()}`;

    console.log("Attendance Details API URL:", url);

    return api.get(url, token);
};

// monthly OT summary per employee
const GetFilteredAttendanceOTSummary = async ({ year, month, employeeId = "" }) => {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    if (employeeId) params.append("employeeId", employeeId);

    const token = getAuthKeyFromLocalStorage();
    const url = `/Attendence/GetFILLTERAttendenceDetails?${params.toString()}`;
    return api.get(url, token);
};

// ============================================================
// Attendance Adjustment endpoints
// ============================================================

const GetAttendanceAdjList = async (adjStatus) => {
    const params = new URLSearchParams();
    if (adjStatus) params.append("p_adjStatus", adjStatus);

    const token = getAuthKeyFromLocalStorage();
    const url = `/AttendanceAdj/GetAttendanceAdjList?${params.toString()}`;

    return api.get(url, token);
};

const GetAppDetailsByUID = async ({ adjStatus, employeeId }) => {
    const params = new URLSearchParams();
    if (adjStatus) params.append("p_adjStatus", adjStatus);
    if (employeeId) params.append("p_employeeId", employeeId);

    const token = getAuthKeyFromLocalStorage();
    const url = `/AttendanceAdj/GetAppDetailsByUID?${params.toString()}`;

    return api.get(url, token);
};

const PostAttendAdj = async (params) => {
    const requestParams = new URLSearchParams();

    requestParams.append("p_employeeId", params.employeeId || "");
    requestParams.append("p_attendanceDate", params.attendanceDate || "");
    requestParams.append("p_inTime", params.inTime || "");
    requestParams.append("p_outTime", params.outTime || "");
    requestParams.append("p_adjType", params.adjType || "");
    requestParams.append("p_adjReason", params.adjReason || "");
    requestParams.append("p_adjStatus", params.adjStatus || "");
    requestParams.append("p_docId", params.docId || "");
    requestParams.append("p_userId", params.userId || "");

    const url = `/AttendanceAdj/PostAttendAdj?${requestParams.toString()}`;
    const token = getAuthKeyFromLocalStorage();

    return api.post(url, null, token);
};

const PostApprovedAdj = async ({ adjustmentId, userId }) => {
    const params = new URLSearchParams();

    params.append("p_adjustmentId", adjustmentId);
    params.append("p_adjId", adjustmentId);
    params.append("p_id", adjustmentId);

    params.append("p_userId", userId);
    params.append("p_approvedBy", userId);
    params.append("p_updatedBy", userId);

    params.append("p_status", "A");

    const url = `/AttendanceAdj/PostApprovedAdj?${params.toString()}`;
    const token = getAuthKeyFromLocalStorage();

    return api.post(url, null, token);
};

const CancelAdj = async ({ adjustmentId, userId }) => {
    const params = new URLSearchParams();

    params.append("p_adjustmentId", adjustmentId);
    params.append("p_adjId", adjustmentId);
    params.append("p_id", adjustmentId);

    params.append("p_userId", userId);
    params.append("p_cancelledBy", userId);

    params.append("p_status", "C");

    const url = `/AttendanceAdj/CancelAdj?${params.toString()}`;
    const token = getAuthKeyFromLocalStorage();

    return api.post(url, null, token);
};

const GetApprovedLeaves = async ({ employeeServiceNo = '' } = {}) => {
  const params = new URLSearchParams();
  params.append("p_leaveStatus", "APPROVED");
  if (employeeServiceNo) params.append("p_empServiceNo", employeeServiceNo);

  const token = getAuthKeyFromLocalStorage();
  const url = `/LeaveApprovels/GetAllRequestLeaveList?${params.toString()}`;
  return api.get(url, token);
};

// ============================================================
// Exports
// ============================================================
const attendanceService = {
  GetFilteredAttendanceDetails,
  GetFilteredAttendanceOTSummary,
  GetApprovedLeaves,   // ← new
  GetAttendanceAdjList,
  GetAppDetailsByUID,
  PostAttendAdj,
  PostApprovedAdj,
  CancelAdj,
};



export default attendanceService;